import { useForm } from "react-hook-form";
import { CreateModal } from "../../../shared/components/Modal";
import Swal from 'sweetalert2';
import usePostContato from "../hooks/usePostContato";
import { ContatoTypes } from "../types";
import { FormModalContato } from "./FormModalContato";

interface ContatoModalProps {
  onCancel: () => void;
  visible: boolean;
}

export function ContatoModal({ onCancel, visible }: ContatoModalProps) {
  const { register, handleSubmit, reset, formState: { errors }, control } = useForm<ContatoTypes>();

  const { mutate: cadastrarContato, isLoading: LoadingButton} = usePostContato(() => resetForm());

  async function onSubmit(data: ContatoTypes) {
    navigator.onLine &&
      await cadastrarContato(data);

    if (!navigator.onLine) {
      Swal.fire({
        title: 'Ocorreu um erro',
        text: 'Por favor, verifique sua conexão com a internet e tente novamente.',
        icon: 'error',
        position: 'center',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F27474'
      })
    }
  }

  function resetForm() {
    onCancel();
    reset();
  }

  return (
    <>
      <CreateModal
        title="Formulário de Contatos"
        isModalOpen={visible}
        onCancel={resetForm}
        onSubmit={handleSubmit(onSubmit)}
        isLoading={LoadingButton}
      >
        <FormModalContato
          register={register}
          errors={errors}
          control={control}
        />
      </CreateModal>
    </>
  );
}
